import React from "react";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import ActionOnAttributes from "./picklist-actions";

//Included React Tabs to generate "Brands" and "Manufacturers" Panel
const AttributeTabs = () => (
    <Tabs>
        <TabList>
            <Tab>Brands</Tab>
            <Tab>Manufacturers</Tab>
        </TabList>
        <TabPanel>
            <ActionOnAttributes attrName="Brand" name="CommonBrand" />
        </TabPanel>
        <TabPanel>
            <ActionOnAttributes attrName="Manufacturer" name="CommonManufacturer" />
        </TabPanel>
    </Tabs>
);

export default AttributeTabs;
